/**
 * Tax Rate Type Definitions
 * Used for configuring and managing tax rates (VAT, GST, Sales Tax, etc.)
 */

export interface TaxRate {
  id: string;
  name: string;
  rate: number; // Percentage (e.g., 20 for 20%)
  description?: string;
  isDefault: boolean;
  isActive: boolean;
  createdDate: Date;
  modifiedDate: Date;
  createdBy?: string;
  modifiedBy?: string;
}

export interface TaxRateFormData {
  name: string;
  rate: number;
  description?: string;
  isDefault: boolean;
  isActive: boolean;
}

export interface TaxCalculation {
  subtotal: number;
  taxRate: number;
  taxAmount: number;
  total: number;
}

export interface TaxBreakdown {
  taxRateName: string;
  taxRate: number;
  netAmount: number;
  taxAmount: number;
}

// UK VAT Rates (can be used as defaults)
export const UK_VAT_RATES = {
  STANDARD: { name: 'Standard VAT', rate: 20, description: 'Standard rate for most goods and services' },
  REDUCED: { name: 'Reduced VAT', rate: 5, description: 'Reduced rate for certain goods and services' },
  ZERO: { name: 'Zero-rated', rate: 0, description: 'Zero-rated goods and services' },
} as const;

// Helper function to get default tax rates
export function getDefaultTaxRates(): TaxRate[] {
  return [
    {
      id: '1',
      name: UK_VAT_RATES.STANDARD.name,
      rate: UK_VAT_RATES.STANDARD.rate,
      description: UK_VAT_RATES.STANDARD.description,
      isDefault: true,
      isActive: true,
      createdDate: new Date(),
      modifiedDate: new Date(),
    },
    {
      id: '2',
      name: UK_VAT_RATES.REDUCED.name,
      rate: UK_VAT_RATES.REDUCED.rate,
      description: UK_VAT_RATES.REDUCED.description,
      isDefault: false,
      isActive: true,
      createdDate: new Date(),
      modifiedDate: new Date(),
    },
    {
      id: '3',
      name: UK_VAT_RATES.ZERO.name,
      rate: UK_VAT_RATES.ZERO.rate,
      description: UK_VAT_RATES.ZERO.description,
      isDefault: false,
      isActive: true,
      createdDate: new Date(),
      modifiedDate: new Date(),
    },
  ];
}
